var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");

var InspectorView = require("./../inspector/inspectorView.js");

var OptionsView = function(model, stateMachine, editorModel, editorView, tabView, rootStateMachine, config, events) {
    var self = this;

    InspectorView.call(this, model, rootStateMachine, editorModel, editorView, events);

    this.model = model;
    this.config = config;
    this.editorView = editorView;

    this._button = tabView.registerButton({
        name: this.model.title(),
        title: this.model.title(),
        sortOrder: 1,
        eventType: lib_core.GuiEvents.OPTIONS_TOGGLE,
        scope: this.model.scope(),
        style: {
            icon: this.model.icon()
        },
        group: "toggle buttons"
    });

    this.model.visible.removeHandlers('inspectorVisible');
    this.model.visible.onChange(this, function(value){
        self.update(value);
    });

    this.hide();
    this.update();
};
lib_core.inherit(OptionsView, InspectorView);

module.exports = OptionsView;

OptionsView.prototype.getTemplate = function () {
    if(!this._template){
        this._template = this.editorView.getTemplate().addInspector("View Options");
        this.model.position(new lib_geometry.Coord(150, 10));
        if(this.model.draggable()) {
            this.attachDraggingListeners(this.editorView);
        }
        this._template.setInvertedHeader();
    }
    return this._template;
};


OptionsView.prototype.update = function (visible) {
    if(!visible) {
        this.hide();
    } else {
        var help_elements = {
            'name': this.model.title()
        };
        var input_elements = this.model.options.toArray();
        this.buildAndShow(input_elements, help_elements);
    }
};

OptionsView.prototype.show = function () {
    InspectorView.prototype.show.apply(this, arguments);
    this._button.setActive();
};

OptionsView.prototype.hide = function () {
    InspectorView.prototype.hide.apply(this, arguments);
    this._button.setInActive();
};
